import React from 'react';
import { jsPDF } from 'jspdf';

const InvoiceOverlay = ({ product, authState, amountInWords, formatDateTime, onClose }) => {
  const handleDownloadPDF = () => {
    const doc = new jsPDF('p', 'pt', 'a4');
    const pageWidth = doc.internal.pageSize.width;
    const padding = 40;

    // Title
    doc.setFontSize(18);
    doc.setTextColor(40);
    doc.text('Invoice cum Receipt', pageWidth / 2, padding, { align: 'center' });
  
    // Space between title and details
    doc.setFontSize(12);
    let yPos = padding + 30;
  
    // Left-side Invoice Details
    doc.setFontSize(10);
    doc.text(`Invoice Number: ${product.invoiceNumber}`, padding, yPos);
    yPos += 15;
    doc.text(`Invoice Date: ${formatDateTime(product.purchaseDate)}`, padding, yPos);
    yPos += 15;
    doc.text(`Receipt Number: ${product.receiptNumber}`, padding, yPos);
  
    // Right-side Seller Details
    yPos = padding + 30;
    const rightStartX = pageWidth - padding - 200; // Adjust the x-position
    doc.text(`Seller Name: ${product.sellerName}`, rightStartX, yPos);
    yPos += 15;
    const sellerAddress = `Seller Address: ${product.sellerAddress}`;
    const wrappedSellerAddress = doc.splitTextToSize(sellerAddress, 150);  
    doc.text(wrappedSellerAddress, rightStartX, yPos);
    // doc.text(`Seller Address: ${product.sellerAddress}`, rightStartX, yPos);
    yPos += 40;
    doc.text(`Seller Contact#: ${product.sellerContact}`, rightStartX, yPos);
    yPos += 15;
    doc.text(`Seller GST#: ${product.sellerGST}`, rightStartX, yPos);
  
    // Customer Details
    yPos += 30;
    doc.text(`Customer Name: ${product.userName}`, padding, yPos);
    yPos += 15;
    doc.text(`Customer Address: Online Product`, padding, yPos);
    yPos += 15;
    doc.text(`Customer Contact: ${authState.user.email}`, padding, yPos);
  
    // Table Headers
    yPos += 30;
    doc.setFontSize(10);
    doc.setFillColor(60, 60, 60);
    doc.setTextColor(255, 255, 255);
    doc.rect(padding, yPos, pageWidth - 2 * padding, 20, 'F');
    doc.text('SN', padding + 10, yPos + 15);
    doc.text('Details', padding + 50, yPos + 15);
    doc.text('GST Rate', padding + 300, yPos + 15);
    doc.text('Qty', padding + 380, yPos + 15);
    doc.text('Rate', padding + 450, yPos + 15);
  
    // Table Rows
    yPos += 30;
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);
  
    // Row 1
    doc.text('1', padding + 10, yPos);
    doc.text(`Item: ${product.productName}`, padding + 50, yPos);
    doc.text(`${product.taxRate}%`, padding + 300, yPos);
    doc.text(`${product.qty}`, padding + 380, yPos);
    doc.text(`₹${(product.salesPrice / (1 + (product.taxRate / 100)))}`, padding + 450, yPos);
  
    // yPos +=15;
    // doc.addImage(rupeeSymbolImgData, 'PNG', 10, 10, 10, 10); 

    yPos +=15;
    doc.text(`HSN Code: ${product.hsnCode}`, padding + 50, yPos);

    yPos +=15;
    const productDesc = `Product Details: ${product.productDesc}`;
    const wrappedProductDesc = doc.splitTextToSize(productDesc, 250);  
    doc.text(wrappedProductDesc, padding + 50, yPos);

    // Summary Rows
    yPos += 150;
    // if(product.isGSTBill) {
      doc.text(`Gross Amount: ₹${(product.salesPrice / (1 + (product.taxRate / 100))).toFixed(2)}`, pageWidth - (padding - 80) - 150, yPos, { align: 'right' });
    // } else {
    //   doc.text(`Gross Amount: ₹${product.salesPrice}`, pageWidth - (padding - 80) - 150, yPos, { align: 'right' });
    // }
    yPos += 15;
    // if(product.isGSTBill) {
      doc.text(`GST: ₹${(product.salesPrice - (product.salesPrice / (1 + (product.taxRate / 100))))}`, pageWidth - (padding - 80) - 150, yPos, { align: 'right' });
    // } else {
    //   doc.text(`GST: ₹0.00}`, pageWidth - (padding - 80) - 150, yPos, { align: 'right' });
    // }
    yPos += 15;
    doc.text(`Invoice Amount: ₹${product.salesPrice}`, pageWidth - (padding - 80) - 150, yPos, { align: 'right' });
    yPos += 15;
    doc.text(`Delivery Charges: ₹${product.deliveryCharges}`, pageWidth - (padding - 80) - 150 , yPos, { align: 'right' });
    yPos += 15;
    doc.text(`Payment Amount: ₹${product.paymentAmount}`, pageWidth - (padding - 80) - 150, yPos, { align: 'right' });
  
    // Terms and Conditions
    yPos += 30;
    doc.setFontSize(10);
    doc.text('Terms & Conditions:', padding, yPos);
    yPos += 15;
    doc.text('1. Product once sold cannot be returned.', padding, yPos);
    yPos += 15;
    doc.text('2. Product can be replaced only for manufacturing defects.', padding, yPos);
  
    // Footer
    yPos += 30;
    doc.text('This is a system-generated invoice and requires no signature.', padding, yPos);
  
    // Save the PDF
    doc.save('GST Invoice '+product.invoiceNumber+'.pdf');
  };
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
      <div className="bg-white shadow-lg rounded-lg overflow-auto" style={{ maxHeight: '90%', maxWidth: '90%', padding: '2rem', margin: '10%' }}>
        <div className="space-y-2 text-gray-700 text-lg">
          <div className="flex justify-between items-center">
            {/* {productName} */}
            <p className="text-2xl font-bold">Invoice cum Receipt</p>
            <div className='flex flex-row'>
              <button
                className="py-2 px-4 bg-red-500 text-white rounded mr-2"
                onClick={onClose}
              >
                Close
              </button>
              <button
                className="py-2 px-4 bg-green-500 text-white rounded"
                onClick={handleDownloadPDF}
              >
                Download
              </button>
            </div>
          </div>
          
          {/* Invoice details */}
          <div className="space-y-2">
            <div className="flex flex-row text-sm">
              <div className='w-6/12 flex-col justify-between border-2'>
                <div><p><strong>Invoice Number:</strong></p><p>{product.invoiceNumber}</p></div>
                <div><p><strong>Invoice Date:</strong></p><p> {formatDateTime(product.purchaseDate)}</p></div>
                <div><p><strong>Receipt Number:</strong></p><p> {product.receiptNumber}</p></div>
              </div>
              <div className='w-6/12 flex-col justify-between border-2'>
                <div><p><strong>Seller Name:</strong> {product.sellerName}</p></div>
                <div><p><strong>Seller Address:</strong> {product.sellerAddress}</p></div>
                <div><p><strong>Seller Contact#:</strong> {product.sellerContact}</p></div>
                <div><p><strong>Seller GST#:</strong> {product.sellerGST}</p></div>
              </div>
            </div>
            <div className="flex flex-row text-sm">
              <div className='w-full flex-col justify-between border-2'>
                <div><p><strong>Customer Name:</strong> {product.userName}</p></div>
                <div><p><strong>Customer Address:</strong> Online Product</p></div>
                <div><p><strong>Customer Contact:</strong> {authState.user.email}</p></div>
              </div>
            </div>
            <table className="min-w-full bg-white border border-gray-300 rounded-lg overflow-hidden text-sm">
              <thead className="bg-gray-800 text-white text-sm">
                <tr>
                  <th className="py-3 px-4 w-1/12">SN</th>
                  <th className="py-3 px-4 w-5/12">Details</th>
                  <th className="py-3 px-4 w-2/12">GST Rate</th>
                  <th className="py-3 px-4 w-1/12">Qty</th>
                  <th className="py-3 px-4 w-1/12">Unit</th>
                  <th className="py-3 px-4 w-2/12">Rate</th>
                </tr>
              </thead>
              <tr className="bg-gray-800 text-sm">
                <td className="py-2 px-4 border-b border-blue-700 w-1/12">1</td>
                <td className="py-2 px-4 border-b border-blue-700 items-start flex flex-col justify-left">
                <p><strong>Item:</strong> {product.productName}</p>
                <p><strong>HSN Code:</strong> {product.hsnCode}</p>
                <p><strong>Item Description:</strong> {product.productDesc}</p>
                </td>
                <td className="py-2 px-4 border-b border-blue-700 w-2/12">{product.taxRate}%</td>
                <td className="py-2 px-4 border-b border-blue-700 w-1/12">{product.qty}</td>
                <td className="py-2 px-4 border-b border-blue-700 w-1/12">Unit</td>
                <td className="py-2 px-4 border-b border-blue-700 w-2/12">
                ₹{(product.salesPrice / (1 + (product.taxRate / 100))).toFixed(2)}
                </td>
              </tr>
                <tr className="bg-gray-800 items-end">
                    <td className="py-2 px-4 border-b border-gray-400 text-right" colSpan="5"><strong>Gross Amount:</strong></td>
                    <td className="py-2 px-4 border-b border-gray-400">
                    ₹{(product.salesPrice / (1 + (product.taxRate / 100))).toFixed(2)}
                    </td>
                </tr>
                <tr className="bg-gray-800">
                    <td className="py-2 px-4 border-b border-gray-400 text-right" colSpan="5"><strong>GST Amount:</strong></td>
                    <td className="py-2 px-4 border-b border-gray-400">
                    ₹{(product.salesPrice - (product.salesPrice / (1 + (product.taxRate / 100)))).toFixed(2)}
                    </td>
                </tr>
                <tr className="bg-gray-800">
                    <td className="py-2 px-4 border-b border-gray-400 text-right" colSpan="5"><strong>Invoice Amount:</strong></td>
                    <td className="py-2 px-4 border-b border-gray-400">
                    ₹{product.salesPrice.toFixed(2)}
                    </td>
                </tr>
                <tr className="bg-gray-800">
                    <td className="py-2 px-4 border-b border-gray-400 text-right" colSpan="5"><strong>Payment Amount:</strong></td>
                    <td className="py-2 px-4 border-b border-gray-400">
                    ₹{product.paymentAmount.toFixed(2)}
                    </td>
                </tr>
                <tr className="bg-gray-800">
                    <td className="py-2 px-4 border-b border-gray-400 text-right" colSpan="5"><strong>Delivery Charges:</strong></td>
                    <td className="py-2 px-4 border-b border-gray-400">
                    ₹{product.deliveryCharges.toFixed(2)}
                    </td>
                </tr>
            </table>
            <div className="py-4 flex-col justify-between border-2">
                <p className="py-2 px-4 text-sm" colSpan="5"><strong>Amount in Words: </strong>
                {amountInWords(product.paymentAmount + product.deliveryCharges)}
                </p>
            </div>
            <div className="py-4 text-sm flex-col justify-between border-2">
              <p><strong>Terms & Conditions:</strong></p>
              <ul>
                <li>Product once sold cannot be returned.</li>
                <li>Product can be replaced only for manufacturing defects.</li>
              </ul>
            </div>
            <div className="text-sm text-gray-600">
              This is a system-generated invoice and requires no signature.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceOverlay;
